export default {
  "fr": {
    "reminder": {
      "actions": {
        "cancel": "Annuler",
        "edit": "Modifier",
        "hideReminders": "Masquez les rappels",
        "save": "Enregistrer",
        "showReminders": "Montrer les rappels"
      },
      "contactType": {
        "customer": "Client",
        "partner": "Partner"
      },
      "labels": {
        "after": "après",
        "before": "avant",
        "click": "Cliquez ici pour définir le rappel",
        "date": "sur {date}",
        "dateAfterDueDate": "Après la date limite",
        "dateAlreadyPassed": "la date est déjà passée",
        "decisionApprovedNotSent": "La décision a été prise. Les rappels qui étaient toujours en attente sont annulés.",
        "dueDate": "la date limite",
        "here": "ici",
        "noReminderSet": "Aucun rappel défini",
        "reminder": "Rappel",
        "reminders": "Rappels",
        "remindersCustomer": "Rappels pour le client",
        "remindersPartners": "Rappels pour les partenaires",
        "sendOnDeadline": "Rappel sera envoyé à la date limite prévue",
        "sendReminder": "Envoyer rappel",
        "sent_at": "Rappel envoyé le {date}",
        "warningReminders": "Les 4 rappels seront écrasés pour chaque décision, y compris ceux qui ne sont pas renseignés."
      },
      "toasts": {
        "update": "Rappel mis à jour avec succès"
      }
    }
  }
}